export default x => x.slice(0, 1).toUpperCase() + x.slice(1)
